import creditEngineRepository, {CreditEngineRepository} from "@/repositories/creditengine/CreditEngineRepository";

export default {
  isFrontPageRequired(loanId) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(
        `loan/${loanId}/bankStatement/frontPageRequired`
    );
  }
}